import React from "react";
import { List, CalendarDays } from "lucide-react";
import { TID } from "@/lib/testIds";
import { cn } from "@/lib/utils";

export default function ViewSwitcher({ view, onChange }) {
  const btn = (key, Icon, label, tid) => (
    <button
      key={key}
      type="button"
      onClick={() => onChange(key)}
      data-testid={tid}
      className={cn(
        "inline-flex items-center gap-1.5 h-8 px-2.5 rounded-md text-xs font-medium transition-colors",
        view === key
          ? "bg-white text-[#0F172A] shadow-sm border border-[#E2E8F0]"
          : "text-[#64748B] hover:text-[#0F172A]"
      )}
    >
      <Icon className="h-3.5 w-3.5" />
      {label}
    </button>
  );
  return (
    <div className="inline-flex items-center gap-0.5 p-0.5 bg-[#F1F5F9] rounded-lg">
      {btn("list", List, "List", TID.viewList)}
      {btn("calendar", CalendarDays, "Calendar", TID.viewCalendar)}
    </div>
  );
}
